import styles from "./style.module.css";

/**
 * Skeleton — reusable shimmer placeholder for loading states.
 *
 * @param {"text"|"circular"|"rectangular"|"rounded"|"pill"} variant - Shape variant
 * @param {number|string} width - Width (px number or CSS string like "100%")
 * @param {number|string} height - Height (px number or CSS string)
 * @param {string} className - Additional CSS class
 * @param {Object} style - Inline style overrides
 *
 * Usage:
 *   <Skeleton variant="text" width={120} height={16} />
 *   <Skeleton variant="circular" width={48} height={48} />
 *   <Skeleton variant="rounded" width="100%" height={180} />
 *   <Skeleton.Group>  — vertical stack with gap
 *   <Skeleton.Row>    — horizontal row with gap
 */
const Skeleton = ({ variant = "text", width, height, className = "", style = {} }) => {
  const variantClass = styles[variant] || "";

  return (
    <div
      className={`${styles.skeleton} ${variantClass} ${className}`}
      style={{
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        ...style,
      }}
    />
  );
};

/** Vertical stack of skeletons with consistent gap */
Skeleton.Group = ({ children, className = "", style = {} }) => (
  <div className={`${styles.group} ${className}`} style={style}>
    {children}
  </div>
);

/** Horizontal row of skeletons with consistent gap */
Skeleton.Row = ({ children, className = "", style = {} }) => (
  <div className={`${styles.row} ${className}`} style={style}>
    {children}
  </div>
);

export default Skeleton;
